/**
 * Lazy-load nested locale JSON into i18next.
 * Stable packs are preloaded; beta packs load on first selection.
 */
import i18n from 'i18next'

const modules = import.meta.glob('./locales/*.json')

const loading = new Map<string, Promise<boolean>>()

export function availableLocaleCodes(): string[] {
  return Object.keys(modules)
    .map((p) => p.match(/\.\/locales\/([a-z0-9-]+)\.json$/i)?.[1])
    .filter((x): x is string => Boolean(x) && x !== 'manifest')
}

export async function ensureLocale(code: string): Promise<boolean> {
  const base = (code.split('-')[0] || code).toLowerCase()
  if (i18n.hasResourceBundle(base, 'translation')) return true

  const path = `./locales/${base}.json`
  if (base === 'manifest' || !modules[path]) return false

  let p = loading.get(base)
  if (!p) {
    p = (async () => {
      const mod = (await modules[path]()) as { default: Record<string, unknown> }
      i18n.addResourceBundle(base, 'translation', mod.default, true, true)
      return true
    })().finally(() => loading.delete(base))
    loading.set(base, p)
  }
  return p
}
